module.exports = __webpack_public_path__ + "static/img/undraw_svg_1.e09916a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/undraw_svg_1.svg
// module id = 5IoZ
// module chunks = 0